import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import {Auth0Provider} from "@auth0/auth0-react";

const App = React.lazy(() => import(/* webpackChunkName: "App" */'./App' ));
const domain = "loosid-admin.us.auth0.com";
const clientId = "CGkX20ZymcftMwPu8CZVnyr6HfAQRuow";


ReactDOM.render(
  <Provider store={configureStore()}>
    <Suspense fallback={<div className="loading" />}>
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={window.location.origin}
            // onRedirectCallback={onRedirectCallback}
        >
            <App />
        </Auth0Provider>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
